module.exports = __webpack_public_path__ + "static/media/Robert Dole - 1996.9b2f9f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Robert Dole - 1996.jpg
// module id = 539
// module chunks = 0